const SCRATCH_UPLOAD_STATUS_KEY = 'scratchUploadStatus';
const SCRATCH_UPLOAD_STATUS_CHANGED = 'scratch-upload-status-changed';

const SCRATCH_UPLOAD_STATUS = {
    SAVING: 'saving',
    SAVED: 'saved'
};

const canUseLocalStorage = () => typeof window !== 'undefined' && window.localStorage;

const getScratchUploadStatus = () => {
    if (!canUseLocalStorage()) return SCRATCH_UPLOAD_STATUS.SAVED;
    try {
        const savedStatus = window.localStorage.getItem(SCRATCH_UPLOAD_STATUS_KEY);
        if (
            savedStatus === SCRATCH_UPLOAD_STATUS.SAVED ||
            savedStatus === SCRATCH_UPLOAD_STATUS.SAVING
        ) {
            return savedStatus;
        }
        return SCRATCH_UPLOAD_STATUS.SAVED;
    } catch (e) {
        return SCRATCH_UPLOAD_STATUS.SAVED;
    }
};

const setScratchUploadStatus = status => {
    if (!canUseLocalStorage()) return;
    try {
        window.localStorage.setItem(SCRATCH_UPLOAD_STATUS_KEY, status);
        window.dispatchEvent(new CustomEvent(SCRATCH_UPLOAD_STATUS_CHANGED, {
            detail: status
        }));
    } catch (e) {
        // no-op: localStorage can fail in private mode or restricted contexts
    }
};

export {
    SCRATCH_UPLOAD_STATUS,
    SCRATCH_UPLOAD_STATUS_CHANGED,
    SCRATCH_UPLOAD_STATUS_KEY,
    getScratchUploadStatus,
    setScratchUploadStatus
};
